var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4455 4.55453C13.8172 2.92621 11.1772 2.92621 9.54887 4.55453L9.545 4.5584L8.91878 5.17641C8.59121 5.4997 8.06359 5.49623 7.7403 5.16866C7.41701 4.84109 7.42048 4.31346 7.74805 3.99018L8.37238 3.374C10.6517 1.09683 14.3455 1.0975 16.624 3.37602C18.9026 5.65455 18.9032 9.34838 16.626 11.6277C16.6253 11.6284 16.6247 11.629 16.624 11.6297L16.0099 12.252C15.6866 12.5796 15.159 12.583 14.8314 12.2597C14.5038 11.9365 14.5003 11.4088 14.8236 11.0813L15.4455 10.4512C17.0738 8.82284 17.0738 6.18284 15.4455 4.55453ZM5.16878 7.74018C5.49635 8.06346 5.49982 8.59109 5.17653 8.91866L4.55466 9.54877C2.92635 11.1771 2.92634 13.8171 4.55465 15.4454C6.18296 17.0737 8.82298 17.0737 10.4513 15.4454L10.4552 15.4415L11.0814 14.8235C11.409 14.5002 11.9366 14.5037 12.2599 14.8313C12.5832 15.1588 12.5797 15.6865 12.2521 16.0097L11.6298 16.6239C11.6291 16.6246 11.6285 16.6252 11.6278 16.6259C9.34844 18.9031 5.65465 18.9024 3.37614 16.6239C1.09762 14.3454 1.09695 10.6516 3.37413 8.37225L3.9903 7.74793C4.31359 7.42036 4.84121 7.41688 5.16878 7.74018ZM12.256 7.74404C12.5814 8.06947 12.5814 8.59711 12.256 8.92255L8.92267 12.2559C8.59723 12.5813 8.0696 12.5813 7.74416 12.2559C7.41872 11.9304 7.41872 11.4028 7.74416 11.0774L11.0775 7.74404C11.4029 7.4186 11.9306 7.4186 12.256 7.74404Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/link-icon.ba83255532729f152a45ef2e703da377.svg";
export { ForwardRef as ReactComponent };